import { styled } from '@linaria/react';

import { fonts, semantic, space } from '../../theme/tokens';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-400']};
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${space['space-300']};
`;

export const HeaderTitle = styled.h3`
  font-family: ${fonts.heading};
  font-size: ${fonts.size.lg};
  font-weight: ${fonts.weight.medium};
  color: ${semantic.text.primary};
  margin: 0;
`;

export const SignInButtonWrapper = styled.div`
  flex-shrink: 0;
`;

export const Stack = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-300']};
`;

export const SplitRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: stretch;

  & > :first-child {
    padding-right: ${space['space-400']};
    border-right: 1px solid ${semantic.border.subtle};
  }

  & > :last-child {
    padding-left: ${space['space-400']};
  }
`;

export const PhoneFieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-100']};
`;

export const SubheadingLabel = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.medium};
  color: ${semantic.text.primary};
`;
